import { Navigate, Outlet } from "react-router-dom";
import { getAuth } from "../components/utils/auth";

export default () => {
  const user = getAuth();
  return user ? <Navigate to="/admin" /> : <Outlet />;
};
